module.exports = __webpack_public_path__ + "img/Icon.922f1e93.png";